import getDealExpiryDateSelector from 'containers/Deals/selector/get-deal-expiry-date'
import shouldShowDealTimerProductUtil from 'containers/Deals/selector/should-show-deal-timer-product/utils/should-show-deal-timer-product/index.js'
import getCurrentDateSelector from 'modules/product/redux/selectors/get-current-date'
import { createSelector } from 'reselect'

const shouldShowDealTimerProductSelector = (variantId) => createSelector(
  getDealExpiryDateSelector(variantId),
  getCurrentDateSelector,
  (endTime, currentDate) => {
    return shouldShowDealTimerProductUtil(endTime, currentDate)
  }
)

export default shouldShowDealTimerProductSelector
